import { InputTag } from 'mixs/base/input_mixin';
export class InputsFile extends InputTag {
  public init() {
    super.init();
    this.watch();
  }
  public onChange(e) {
    if(this.opts.noDispatch){ return; }
    this.dispatch({value: e.target.value});
  }
}
riot.mixin("inputs.file", InputsFile as riot.TagMixin)
